/**
 * Query-key anchors shared by the Account and Team session surfaces.
 * Keeping these keys outside either feature prevents one surface from
 * becoming stale when the other surface revokes the same logical session.
 */
export const sessionSurfaceQueryKeys = {
  account: ['settings', 'security-sessions'] as const,
  team: ['team'] as const,
};

/**
 * Session revocations are security state. Polling keeps independently open
 * browsers convergent even when no realtime channel is available.
 */
export const SESSION_SURFACE_REFETCH_INTERVAL_MS = 10_000;
